/* eslint-disable */
import { Inject, Injectable, Optional } from '@angular/core';
import { PlatformLocation, APP_BASE_HREF, LocationStrategy, Location } from '@angular/common';
import { ApplicationActions } from '../../actions/application.actions';

@Injectable()
export class NoHistoryStrategy extends LocationStrategy {
  _baseHref = '';

  constructor(_platformLocation, appActions, _baseHref) {
    super();
    this.appActions = appActions;
    this._platformLocation = _platformLocation;
    this._baseHref = _baseHref != null ? _baseHref : this._platformLocation.getBaseHrefFromDOM();

    this.currentLocation = '';
    this.lastLocation = '';

    this.registerUnload();
  }

  registerUnload() {

    // window.onbeforeunload = (e) => {
    //   if (this.environment !== 'dev' && this.canUnload === false) {
    //     const dialogText = 'Are you sure you wish to leave the page? Your data will not be saved.';
    //     // eslint-disable-next-line no-param-reassign
    //     this.appActions.setData('sendDTM', true);
    //     e.returnValue = dialogText;
    //     return true;
    //   }
    // };
  }

  get environment() {
    // return this.appActions.getData('environment', 'dev');
    return 'Prod';
  }

  get canUnload() {
    return this.appActions.getData('canUnload', false);
  }

  onPopState(fn) {
    this._platformLocation.onPopState(fn);
    this._platformLocation.onHashChange(fn);
  }

  getBaseHref() { return this._baseHref; }

  path(includeHash = false) {
    const pathname = this._platformLocation.pathname +
        Location.normalizeQueryParams(this._platformLocation.search);
    const hash = this._platformLocation.hash;
    return hash && includeHash ? `${pathname}${hash}` : pathname;
  }

  prepareExternalUrl(internal) {
    return Location.joinWithSlash(this._baseHref, internal);
  }

  pushState(state, title, url, queryParams) {

    const externalUrl = this.prepareExternalUrl(url + Location.normalizeQueryParams(queryParams));
    if (this.environment === 'dev') {
      this._platformLocation.pushState(state, title, externalUrl);
    } else {
      this._platformLocation.replaceState(state, title, externalUrl);
    }
  }

  replaceState(state, title, url, queryParams) {
    const externalUrl = this.prepareExternalUrl(url + Location.normalizeQueryParams(queryParams));
    this._platformLocation.replaceState(state, title, externalUrl);
    this.lastLocation = url;
  }

  forward() { this._platformLocation.forward(); }

  back() { this._platformLocation.back(); }
}

NoHistoryStrategy.parameters = [
  [PlatformLocation],
  [ApplicationActions],
  [new Optional(), new Inject(APP_BASE_HREF)],
];